export const ALERTS_DOMAIN = "pseudoModal/";

export const SET_EXERCISENAME = ALERTS_DOMAIN + "setExerciseName";
export const SET_EXERCISEZONEID = ALERTS_DOMAIN + "setExerciseZoneId";


